import axios from '@/components/api/axios';

async function getMemberInfo() {
  const res = await axios.axiosGet('/api/memberInfo/getOne', null);
  return res;
}

export default {
  getMemberInfo
}



// WEBPACK FOOTER //
// ./src/components/api/memberInfo.js